<template>
  <div id="versionNumber">
    <ots-main-title></ots-main-title>
    <ots-table-group-new
      :messageDescript="messageDescript"
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      @search="getTableData"
    ></ots-table-group-new>
  </div>
</template>
<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import {
  versionQueryListAPI ,
  getPlanAllSessionAPI
} from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      messageDescript : "",
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        }
      ],
      requestForm: {
        planId: '',
      },
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "场次",
          prop: "name",
        },
        {
          title: "版本号",
          prop: "versionNumberName",
        },
        {
          title: "生成时间",
          prop: "lastModifyDate",
        },
      ],
      tableData: [],
    }
  },
  methods: {
    async initData() {
      const { data: planData } = await getSelectPlanFn({needAudit: 31});
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
      await this.getVersionInfo();
    },
    async getVersionInfo() {
      const res = await versionQueryListAPI({ planId: this.requestForm.planId });
      if (res.code == 1 && res.data && res.data.length > 0) {
        const firstData = res.data[0];
        this.messageDescript = `当前考试数据包版本号：${firstData.versionCode}，生成时间 ${firstData.createTime.replace("T", " ")}`;
      }else{
        this.messageDescript = "";
      }
    },
    async getTableData() {
      let params = { ...this.requestForm };
      const { data, code } = await getPlanAllSessionAPI(params);
      if (code == 1) {
        this.tableData = data;
      }
    },
  },
  mounted() {
    this.initData();
  },
  watch: {
    "requestForm.planId": function() {
      this.getTableData();
      this.getVersionInfo();
    }
  }
}
</script>